import { Trans } from '@lingui/react/macro'
import { ChevronLeft, ChevronRight } from 'lucide-react'

interface Props {
  page: number
  limit: number
  total: number
  onNextClick: () => void
  onPreviousClick: () => void
  nextCursor: string | undefined
  isPreviousAvailable: boolean
  goToFirstPage: () => void
}

const getPageItems = (page: number, limit = 0, total = 0) => {
  const start = (page - 1) * limit + 1
  const end = Math.min(page * limit, total)
  return { start, end }
}

export const Pagination = ({
  limit,
  page,
  total,
  onNextClick,
  onPreviousClick,
  nextCursor,
  isPreviousAvailable,
}: Props) => {
  const totalPages = Math.ceil(total / limit)
  const { start, end } = getPageItems(page, limit, total)

  return (
    <div className="flex flex-col sm:flex-row justify-between items-center px-[16px] py-[8px]">
      <div className="text-sm text-gray-700">
        <span>
          <Trans>
            {start}-{end} of {total}
          </Trans>
        </span>
      </div>

      <div className="flex items-center gap-[8px]">
        {/* todo: hiding first/last buttons for further clarifications with design */}
        {/* <button type="button"  data-testid="pagination-first-button" onClick={goToFirstPage} disabled={!isPreviousAvailable}> */}
        {/*  <ChevronFirst size={16} color={isPreviousAvailable ? 'black' : 'gray'} /> */}
        {/* </button> */}
        <button
          type="button"
          data-testid="pagination-previous-button"
          onClick={onPreviousClick}
          disabled={!isPreviousAvailable}
        >
          <ChevronLeft size={16} color={isPreviousAvailable ? 'black' : 'gray'} />
        </button>
        {!!totalPages && (
          <div className="text-sm text-gray-700">
            <Trans>
              Page {page} of {totalPages}
            </Trans>
          </div>
        )}
        <button
          type="button"
          data-testid="pagination-next-button"
          onClick={onNextClick}
          disabled={!nextCursor}
        >
          <ChevronRight size={16} color={nextCursor ? 'black' : 'gray'} />
        </button>
        {/* todo: hiding first/last buttons for further clarifications with design */}
        {/* <button type="button"  data-testid="pagination-last-button" onClick={() => {}} disabled={!totalPages || page === totalPages}> */}
        {/*  <ChevronLast size={16} color={!totalPages || page === totalPages ? 'gray' : 'black'} /> */}
        {/* </button> */}
      </div>
    </div>
  )
}
